import ScopeConstants from "constants/ScopeConstants"
import { FormActionReducer } from "@gman/gman-redux"

export const ExpensesTeamByDueDateReducer = (
  state = {
    ...FormActionReducer.defaultPageState(),
    ...FormActionReducer.defaultSearchOptions("Description", 10),
    ...FormActionReducer.defaultRecordState(),
    ...FormActionReducer.defaultTabs()
  },
  action) => {

    if (action.scope === ScopeConstants.EXPENSE_TEAM_BY_DUE_DATE) {
    if (action.type === "CHANGE_PAGE_SIZE") {
      return {
        ...state,
        searchOptions: {
          ...state.searchOptions,
          pageSize: action.pageSize
        }
      }
    }
    return FormActionReducer.reduce(action, state)
  }

  return state
}